import moment from "moment"

const TimeCell = ({ time }) => {
    if (!time) return '-'

    return <span>{moment.utc(time).local().format('HH:mm')}</span>
}

export default TimeCell